import React, { useState } from "react";
import { toast } from "react-toastify";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";

// import JS files
import PanelTemplate from "../../../shares/PanelTemplate";
import PanelFilter from "../../../shares/PanelFilter";
import MuiPagination from "../../../shares/MuiPagination";
import PanelTable from "../../../shares/PanelTable";
import OrderDetails from "./OrderDetails";
import RemoveOrder from "./RemoveOrder";
import useFetch from "../../../../context/useFetch";
import { useUserData } from "../../../../context/UserDataContext";
import { EmptyData, fixNumbers } from "../../../../utils";
import PrintIcon from "@mui/icons-material/Print";
import MuiButton from "../../../shares/MuiButton";
import { useNavigate } from "react-router-dom";
import PrintOrderDetails from "../PrintOrderDetails";

// import Others files
import PrintOrderDetailNavigator from '../PrintOrderDetailNavigator';

const headersList = [
  { colName: "unique_id", name: "سند" },
  { colName: "created_at", name: "تاریخ ثبت سفارش" },
  { colName: "total", name: "وزن کل" },
  { colName: "details", name: "جزییات سفارش" },
  { colName: 'print', name: 'چاپ سفارش' },

  { colName: "remove", name: "لغو سفارش" },
];
const mobileHeadersList = [
  { colName: "unique_id", name: "سند" },
  { colName: "created_at", name: "تاریخ ثبت سفارش" },
  { colName: "total", name: "وزن کل" },
];
const dataKey = ["unique_id", "created_at", "total"];

const PreOrders = (props) => {
  const [isFilterOn, setIsFilterOn] = useState(false);
  const [codeFilter, setCodeFilter] = useState(null);
  const [dateFilter, setDateFilter] = useState(null);

  const { userData } = useUserData();

  const [currentOerdersList, setCurrentOerdersList] = useState({ results: [] });

  const filterList = [
    {
      type: "textField",
      label_fa: "سند",
      label_en: "code",
      state: codeFilter,
    },
    {
      type: "datePicker",
      label_fa: "تاریخ ثبت سفارش",
      label_en: "date",
      state: dateFilter,
    },
  ];

  const [paginationPageInfo, setPaginationPageInfo] = useState({
    current: 1,
    pageSize: 30,
    count: 0,
  });
  const navigate = useNavigate();
  const getCreateOrderApi = useFetch({
    method: "get",
    url: `User_Service/${userData.username}/customer_get_create_order`,
    params: { unique_id: fixNumbers(codeFilter), date: dateFilter },
    trigger: true,
    pagination: paginationPageInfo,
    setter: setCurrentOerdersList,
    argFunc: (res) => {
      setPaginationPageInfo({
        current: res.current,
        pageSize: res.pageSize,
        count: res.count,
        next: res.next,
        previous: res.previous,
      });
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  const update_filter = (state, e) => {
    if (state == "code") setCodeFilter(e.length > 0 ? e : null);
    if (state == "date") setDateFilter(e.length > 0 ? e : null);
  };
  const filter = () => {
    if (codeFilter !== null || dateFilter !== null) {
      setIsFilterOn(true);
      getCreateOrderApi.reFetch();
    }
  };

  const reset_filter = () => {
    setCodeFilter(null);
    setDateFilter(null);
    getCreateOrderApi.reFetch();
  };

  const buttonsList = [
    {
      label: "جزییات سفارش",
      component: (it) => (
        <OrderDetails selectedRow={it} getCreateOrderApi={getCreateOrderApi} />
      ),
    },
  ];
  const actionsList = [
    {
      label: "چاپ",
      component: (it) => <PrintOrderDetailNavigator inCurrentOrder selectedRow={it} />,
    },
    {
      label: "لغو سفارش",
      component: (it) => (
        <RemoveOrder selectedRow={it} getCreateOrderApi={getCreateOrderApi} />
      ),
    },
  ];
  const onChangePage = (e, page) => {
    setPaginationPageInfo({
      ...paginationPageInfo,
      current: page,
    });
    setCurrentOerdersList({ results: [] });

    getCreateOrderApi.reFetch();
  };

  const handelPrintReport = () => {
    // navigate(`/print-new-orders/new/${codeFilter}/${dateFilter}`);
    window.open(
      `/print-new-orders/new/${codeFilter}/${dateFilter}`,
      "_blank"
      // "rel=noopener noreferrer"
    );
  };
  return (
    <>
      <PanelTemplate sidebarActiveLink="new-orders">
        <>
          <div className="panel-main-header">
            <span>سفارش‌های ثبت شده</span>
          </div>
          <PanelFilter
            header="فیلتر سفارش‌ها:"
            list={filterList}
            update_filter={update_filter}
            filter={filter}
            reset_filter={reset_filter}
          />
          <div className="flex justify-end">
            <MuiButton
              onClick={handelPrintReport}
              variant="outlined"
              icon={<PrintIcon />}
              color="primary"
              text="چاپ گزارش"
              margin="mr-2"
            />
          </div>
          <PanelTable
            header="لیست سفارش‌های ثبت‌شده:"
            headers={headersList}
            mobileHeaders={mobileHeadersList}
            data={currentOerdersList.results}
            dataKey={dataKey}
            buttons={buttonsList}
            actions={actionsList}
            icon={<AccountBalanceIcon />}
          />
          <MuiPagination
            onChange={onChangePage}
            count={Math.ceil(
              paginationPageInfo.count / paginationPageInfo.pageSize
            )}
          />
        </>
      </PanelTemplate>
    </>
  );
};

export default PreOrders;
